import { isToasterError } from '@/hooks/useFetch/utils';
import type { ErrorResponse } from '@/types/apiTypes';
import { getParsedError } from '@/utils/getParsedError';

export function getRateLimitErrorMessage(errorBody: unknown): string {
  if (isToasterError(errorBody)) {
    return getParsedError((errorBody as ErrorResponse<unknown>).errors.details, 429);
  }

  return getParsedError(errorBody, 429);
}
